module.exports = __webpack_public_path__ + "img/bracket-2.6d440b16.svg";